<template>
  <div class="bg-50 image">
    <img :src="imageUrl" class="img-fluid" :alt="alt" />
  </div>
</template>

<script>
import { getImageUrlForKey } from '../../helpers'
export default {
  props: ['src', 'width', 'height', 'fit', 'alt'],

  computed: {
    imageUrl: function () {
      return this.src
        ? getImageUrlForKey(this.src, this.width, this.height, this.fit)
        : 'https://via.placeholder.com/1140x600?text=Saknar bild'
    }
  }
}
</script>
